import { render, staticRenderFns } from "./SchoolPoster.vue?vue&type=template&id=73253288&scoped=true&"
import script from "./SchoolPoster.vue?vue&type=script&lang=js&"
export * from "./SchoolPoster.vue?vue&type=script&lang=js&"
import style0 from "./SchoolPoster.vue?vue&type=style&index=0&id=73253288&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73253288",
  null
  
)

export default component.exports